var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable sonarjs/cognitive-complexity */
import React, { useState, useEffect, useRef } from 'react';
import FocusTrap from 'focus-trap-react';
import { mapToCssModules } from '../../utils/className';
export const SmlsModal = (_a) => {
    var { id, idBtnClose = 'btn_close', children = '', className = '', isOpen = true, role = 'dialog', defaultHeader = true, type, hideHeader = false, backdrop = true, initialFocus = 'div', onEnter = () => null, toggle = () => null, onOpened = () => null, onClosed = () => null, onExit = () => null } = _a, props = __rest(_a, ["id", "idBtnClose", "children", "className", "isOpen", "role", "defaultHeader", "type", "hideHeader", "backdrop", "initialFocus", "onEnter", "toggle", "onOpened", "onClosed", "onExit"]);
    const modal = useRef(null);
    const [open, setOpen] = useState(isOpen);
    const [modalStyle, setModalStyle] = useState({});
    const handleIsOpen = (e) => {
        if (toggle)
            return toggle(e);
        return setOpen((prev) => !prev);
    };
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!open)
                return;
            if (modal.current && toggle && !modal.current.contains(event.target)) {
                toggle(event);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [modal, open, toggle]);
    useEffect(() => {
        setOpen(isOpen);
        if (isOpen) {
            onOpened();
            onEnter();
        }
    }, [isOpen]);
    useEffect(() => {
        if (isOpen === false && open === true) {
            onClosed();
            onExit();
            setTimeout(() => {
                setModalStyle({
                    zIndex: -1,
                    display: type === 'full' || !type ? 'none' : 'block',
                });
            }, type === 'full' ? 950 : 450);
        }
    }, [isOpen]);
    useEffect(() => {
        if (isOpen) {
            if (!open) {
                setModalStyle({
                    zIndex: -1,
                    display: type ? 'block' : 'none',
                });
            }
            else {
                setModalStyle({
                    zIndex: 1050,
                    display: 'block',
                });
            }
        }
    }, [open]);
    useEffect(() => {
        if (!isOpen) {
            if (!open && type === 'full') {
                setModalStyle({
                    display: 'none',
                });
            }
            else if (!open) {
                setModalStyle({
                    zIndex: -1,
                    display: type ? 'block' : 'none',
                });
            }
            else {
                setModalStyle({
                    zIndex: 1050,
                    display: 'block',
                });
            }
        }
    }, []);
    return (React.createElement(FocusTrap, { active: open, focusTrapOptions: {
            allowOutsideClick: true,
            delayInitialFocus: true,
            fallbackFocus: 'div',
            initialFocus,
        } },
        React.createElement("div", { className: mapToCssModules([
                className,
                'modal',
                'fade',
                open ? 'show' : undefined,
                backdrop ? 'backdrop' : '',
                'trap',
            ]), id: id, tabIndex: -1, role: role, style: modalStyle },
            React.createElement("div", Object.assign({ ref: modal, className: mapToCssModules(['modal-dialog', type]) }, props),
                React.createElement("div", { className: "modal-content" },
                    defaultHeader && (React.createElement("div", { className: `modal-header${!hideHeader ? '' : ' hidden'}` },
                        React.createElement("button", { id: idBtnClose, type: "button", className: "smls-btn-close", "data-dismiss": "modal", "aria-label": "Close", onClick: handleIsOpen },
                            React.createElement("i", { className: "material-icons notranslate" }, "\uE5CD")))),
                    children)))));
};
//# sourceMappingURL=index.js.map